import { Injectable } from '@angular/core';

@Injectable()
export class ToolService {

  constructor() { }

  toDictionary(key: string, objArr: any[]): any {
    if (!key) throw Error('Argument \'key\' cannot be null or empty');
    if (!objArr) return {};
    if (!Array.isArray(objArr)) throw Error('Argument \'objArr\' must be an array');
    if (!objArr.length) return {};

    return objArr.reduce((aggregate, current: any) => {
      if (!current[key]) return aggregate;
      aggregate[current[key]] = current;
      return aggregate;
    }, {});
  }

  clone(obj: any): any {
    if (!obj || JSON.stringify(obj) === '{}') return obj;

    if (typeof(obj) !== 'object') return obj;

    let result: any;

    switch (true) {
      case obj instanceof Array:
        result = [];
        for (let i = 0; i < obj.length; i++) result.push(this.clone(obj[i]));
      break;
      case typeof obj.getMonth === 'function' && obj instanceof Date:
        result = new Date(obj);
      break;
      default:
        result = {};
        const keys = Object.keys(obj);
        for (let i = 0; i < keys.length; i++) {
          result[keys[i]] = this.clone(obj[keys[i]]);
        }
      break;
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tool.service.ts